import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  ImageListItemBar,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import ImageListItem, {
  imageListItemClasses,
} from '@mui/material/ImageListItem';
import { getAllActions } from '../../graphql/queries';
import { API } from '../../services/amplifyCompat';
import { styled } from '@mui/material/styles';
import QuizDialog from './QuizDialog';

const StyledImageListItemBar = styled(ImageListItemBar)`
  .MuiImageListItemBar-title {
    overflow: visible;
    white-space: normal;
    overflow-wrap: break-word;
    font-size: 1.3rem;
    color: #0F172A;
    text-align: center;
  }
`;

const StyledImageListItem = styled(ImageListItem)`
  .MuiImageListItem-img {
    border-radius: 7px;
    height: 278px;
    margin-bottom: 8px;
    width: 100%;
  }
`;

const ManageQuizzes = () => {
  const [actionOptions, setActionOptions] = useState();
  const [selectedAction, setSelectedAction] = useState();
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [iconRevision, setIconRevision] = useState(() => Date.now());

  useEffect(() => {
    setOpenActionDialog(true);
  }, [selectedAction]);

  const handleClose = () => {
    setOpenActionDialog(false);
    setSelectedAction(null);
  };

  const getActions = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const res = await API.graphql({
        query: getAllActions,
      });
      const actions = res.data.getAllActions;
      setIconRevision((revision) => revision + 1);
      setActionOptions(actions);
    } catch (error) {
      console.error('Failed to load actions for quizzes:', error);
      setFetchError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getActions();
  }, []);

  const iconSrc = (action) => {
    if (!action.action_icon) return null;
    const base = action.action_icon;
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}w=248&fit=crop&auto=format&v=${iconRevision}`;
  };

  return (
    <Grid
      item
      sx={{
        minHeight: '50vh'
      }}
    >
      {loading && !actionOptions && <CircularProgress />}
      {fetchError && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <Button color="inherit" size="small" onClick={getActions}>
              Retry
            </Button>
          }
        >
          Failed to load quizzes. Please try again.
        </Alert>
      )}
      <Box
        sx={{
          display: 'grid',
          gap: '20px',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          rowGap: 2,
          [`& .${imageListItemClasses.root}`]: {
            display: 'flex',
            flexDirection: 'column',
          },
          justifyItems: 'center',
        }}
      >
        {actionOptions &&
          actionOptions.map((action, index) => (
            <StyledImageListItem
              key={index}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  opacity: '0.7',
                },
                filter: action.is_hidden && 'grayscale(100%)',
                width: '100%',
              }}
              onClick={() => setSelectedAction(action)}
            >
              {action.action_icon ? (
                <img
                  src={iconSrc(action)}
                  alt={action.action_name}
                  loading="lazy"
                />
              ) : (
                <Box
                  sx={{
                    backgroundColor: '#B4EEB4',
                    borderRadius: '7px',
                    height: 278,
                    width: '100%',
                    marginBottom: '8px',
                  }}
                />
              )}
              <StyledImageListItemBar
                title={action.action_name}
                position="below"
              />
            </StyledImageListItem>
          ))}
        {selectedAction && (
          <QuizDialog
            action={selectedAction}
            open={openActionDialog}
            handleClose={handleClose}
          />
        )}
      </Box>
    </Grid>
  );
};
export default ManageQuizzes;
